import { createContext, useContext } from "react";

const FormDataContext = createContext();

const useFormData = () => useContext(FormDataContext);

export { FormDataContext, useFormData };